import { h } from 'preact'

type Props = {
    count: number,
    customClass? : string
}

const Count = ({ count, customClass='' }: Props) =>
<div className={`instant-search__results-count ${customClass}`}>
    {count}
</div>

export default Count
